
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("iaij5", function(module, exports) {

$parcel$export(module.exports, "AppWeb", function () { return $d3975c84f8f56ac4$export$81d624c0523d78e; });

var $jr9F2 = parcelRequire("jr9F2");
class $d3975c84f8f56ac4$export$81d624c0523d78e extends (0, $jr9F2.WebPlugin) {
    constructor(){
        super();
        this.handleVisibilityChange = ()=>{
            const data = {
                isActive: document.hidden !== true
            };
            this.notifyListeners('appStateChange', data);
            if (document.hidden) this.notifyListeners('pause', null);
            else this.notifyListeners('resume', null);
        };
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    exitApp() {
        throw this.unimplemented('Not implemented on web.');
    }
    async getInfo() {
        throw this.unimplemented('Not implemented on web.');
    }
    async getLaunchUrl() {
        return {
            url: ''
        };
    }
    async getState() {
        return {
            isActive: document.hidden !== true
        };
    }
    async minimizeApp() {
        throw this.unimplemented('Not implemented on web.');
    }
}

});


//# sourceMappingURL=web.d8030fb2.js.map
